export const useUserHistory = () => {
    const { $api, $auth } = useNuxtApp()

    function userHistoryHandler(item: any) {
        const action = checkContentType(item);
        addUserHistory(item.id, action, item.contentType);
    }
    function checkContentType(item: any): string {
        switch (item.contentType?.toLowerCase()) {
            case 'full_track_music':
            case 'album':
            case 'artist':
            case 'playlist':
            case 'online_game':
            case 'game':
            case 'full_length_video':
            case 'videocollection':
            case 'video':
            case 'podcast':
            case 'podcastcollection':
            case 'audio_book_chapter':
                return 'PLAY';
            default:
                return '';
        }
    }
    async function addUserHistory(articleId: number, action: string, contentType: string) {
        if ($auth.user?.roles[0] !== 'user') {
            return;
        }
        return await $api.endPoints.addUserHistory(articleId, action, contentType);
    }

    return {
        userHistoryHandler,
        checkContentType,
        addUserHistory
    }

}